/* ==========================================================================
   Nexos · Conversión del carro (Sergio, 03-11-2026)
   1. "Completa tu compra": bajo la barra de envío gratis del carro, 3-4 productos
      baratos y muy vendidos que alcanzan (o acercan) el monto del envío gratis.
   2. Franja de confianza en la ficha: despacho, retiro, garantía y medios de pago.
   3. "Pide cotización o factura" (solo donde está activo): formulario que llega
      al vendedor de la web por Nexos.
   Lo administra Nexos (#diag conversion): este archivo se reescribe, no editar a mano.
   Datos: <script id="nx-conv-data"> que arma snippets/nx-conversion.liquid.
   ========================================================================== */
(function () {
  'use strict';
  var dataEl = document.getElementById('nx-conv-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var U = Number(D.umbral) || 0;
  var T = D.textos || {};
  var COT = D.cotizar || null;
  var PRODS = (D.productos || []).filter(function (p) { return p && p.id && p.p > 0; });
  var ANCLAS = D.anclas || [];
  var EXCLUIR = (D.excluir || []).map(String);
  var EXTRA = D.extra && D.extra.id ? D.extra : null;

  function money(v) {
    try { return '$' + Math.round(v).toLocaleString('es-CL'); }
    catch (e) { return '$' + String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function enCarro() { return /^\/cart\/?$/.test(location.pathname); }
  function enFicha() { return location.pathname.indexOf('/products/') !== -1; }

  var escribiendo = false;
  function sinEco(fn) { return function () { if (!escribiendo) fn(); }; }
  function escribir(fn) { escribiendo = true; try { fn(); } finally { setTimeout(function () { escribiendo = false; }, 0); } }

  /* ---------------- Carro ---------------- */
  var cart = null;
  function mercaderia() {
    if (!cart) return 0;
    var t = cart.total_price || 0;
    (cart.items || []).forEach(function (i) { if (EXCLUIR.indexOf(String(i.sku || '')) !== -1) t -= i.final_line_price || i.line_price || 0; });
    return Math.max(0, t) / 100;
  }
  var pidiendo = null;
  function leerCarro() {
    if (pidiendo) return pidiendo;
    pidiendo = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; pintar(); })
      .catch(function () {})
      .then(function () { pidiendo = null; });
    return pidiendo;
  }
  var tCarro = null;
  function leerPronto() { clearTimeout(tCarro); tCarro = setTimeout(leerCarro, 350); }

  /* ---------------- 1. Completa tu compra ---------------- */
  function elegir(falta) {
    var ids = {}, hs = {};
    (cart && cart.items || []).forEach(function (i) { ids[String(i.variant_id)] = 1; hs[i.handle] = 1; });
    var c = PRODS.filter(function (p) { return !ids[String(p.id)] && !hs[p.h]; });
    var alcanzan = c.filter(function (p) { return p.p >= falta; }).sort(function (a, b) { return a.p - b.p; });
    var acercan = c.filter(function (p) { return p.p < falta; }).sort(function (a, b) { return b.p - a.p; });
    return { lista: alcanzan.concat(acercan).slice(0, 4), alcanza: alcanzan.length > 0 };
  }
  function htmlSug() {
    if (!U || !cart || !cart.item_count || !PRODS.length) return '';
    var falta = U - mercaderia();
    if (falta <= 0) return '';
    var e = elegir(falta);
    if (!e.lista.length) return '';
    var titulo = e.alcanza ? (T.sug_titulo || 'Suma uno de estos y tu pedido viaja gratis') : (T.sug_titulo_cerca || 'Te acercan al envío gratis');
    return '<p class="nx-sug__t">' + esc(titulo) + ' <span>(te faltan ' + money(falta) + ')</span></p>' +
      '<div class="nx-sug__grid">' + e.lista.map(function (p) {
        return '<div class="nx-sug__it">' +
          (p.img ? '<a href="' + esc(p.url) + '" class="nx-sug__img"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="80" height="80"></a>' : '') +
          '<a href="' + esc(p.url) + '" class="nx-sug__n">' + esc(p.t) + '</a>' +
          '<b class="nx-sug__p">' + money(p.p) + '</b>' +
          '<button type="button" class="nx-sug__btn" data-nx-add="' + esc(p.id) + '">Agregar</button>' +
          '</div>';
      }).join('') + '</div>';
  }
  function anclas() {
    var out = [];
    ANCLAS.forEach(function (sel) { try { [].forEach.call(document.querySelectorAll(sel), function (el) { out.push(el); }); } catch (e) {} });
    if (!out.length && enCarro()) { var f = document.querySelector('main form[action$="/cart"], form[action$="/cart"]'); if (f) out.push(f); }
    return out;
  }
  function bloqueTras(el, clase) {
    var n = el.nextElementSibling;
    if (n && n.classList && n.classList.contains(clase)) return n;
    var b = document.createElement('div');
    b.className = clase;
    el.parentNode.insertBefore(b, el.nextSibling);
    return b;
  }
  function pintarSug() {
    var h = htmlSug();
    var cot = COT && COT.url ? htmlCotCarro() : '';
    anclas().forEach(function (el) {
      if (!el.parentNode) return;
      var b = bloqueTras(el, 'nx-sug');
      var todo = h + htmlExtra() + (cot && (enCarro() || COT.en_drawer) ? cot : '');
      if (b.getAttribute('data-nx') === todo) return;
      b.setAttribute('data-nx', todo);
      b.innerHTML = todo;
      b.hidden = !todo;
    });
  }

  /* ---------------- Servicio opcional (ej. capacitación) ---------------- */
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function esExtra(i) { return EXTRA && String(i.variant_id) === String(EXTRA.id); }
  function htmlExtra() {
    if (!EXTRA || !cart || !cart.item_count || !enCarro()) return '';
    var dentro = (cart.items || []).some(esExtra);
    var maquina = (cart.items || []).some(function (i) {
      if (esExtra(i)) return false;
      var t = norm((i.product_type || '') + ' ' + (i.product_title || ''));
      return (i.final_price || i.price || 0) / 100 >= (EXTRA.precio_min || 0) && (EXTRA.claves || []).some(function (k) { return t.indexOf(norm(k)) !== -1; });
    });
    if (!maquina && !dentro) return '';
    return '<label class="nx-extra' + (dentro ? ' is-on' : '') + '"><input type="checkbox" data-nx-extra' + (dentro ? ' checked' : '') + '>' +
      '<span><b>' + esc(EXTRA.titulo) + '</b><small>' + esc(EXTRA.desc) + '</small></span><b class="nx-extra__p">+' + money(EXTRA.precio) + '</b></label>';
  }

  /* ---------------- 3. Cotización / factura ---------------- */
  function htmlCotCarro() {
    if (!cart || !cart.item_count) return '';
    return '<div class="nx-cot"><span>' + esc(COT.texto_carro || '¿Necesitas factura o comprar por volumen?') + '</span> ' +
      '<button type="button" class="nx-cot__btn" data-nx-cot="carro">' + esc(COT.boton || 'Pide una cotización') + '</button></div>';
  }
  var modal = null;
  function abrirCot(origen) {
    if (!COT || !COT.url) return;
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'nx-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML =
        '<div class="nx-modal__box">' +
        '<button type="button" class="nx-modal__x" aria-label="Cerrar">&times;</button>' +
        '<h3>' + esc(COT.titulo || 'Pide tu cotización') + '</h3>' +
        '<p class="nx-modal__sub">' + esc(COT.subtitulo || 'Te respondemos por correo o WhatsApp en horario hábil.') + '</p>' +
        '<form class="nx-cot__f" novalidate>' +
        '<input name="nombre" placeholder="Nombre y apellido *" autocomplete="name" required>' +
        '<input name="email" type="email" placeholder="Correo *" autocomplete="email" required>' +
        '<input name="telefono" type="tel" placeholder="Teléfono / WhatsApp *" autocomplete="tel" required>' +
        '<input name="empresa" placeholder="Empresa (si necesitas factura)" autocomplete="organization">' +
        '<input name="rut" placeholder="RUT de la empresa (opcional)">' +
        '<textarea name="comentario" rows="3" placeholder="Cantidades, plazos o lo que necesites"></textarea>' +
        '<input name="web" class="nx-hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<p class="nx-cot__msg" role="status" aria-live="polite"></p>' +
        '<button type="submit" class="nx-cot__btn nx-cot__send">Enviar solicitud</button>' +
        '</form></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('nx-modal__x')) modal.hidden = true; });
      modal.querySelector('form').addEventListener('submit', enviarCot);
    }
    modal.setAttribute('data-origen', origen);
    modal.hidden = false;
    var f = modal.querySelector('form');
    f.hidden = false;
    f.querySelector('.nx-cot__msg').textContent = '';
    setTimeout(function () { var i = f.querySelector('input[name=nombre]'); if (i) i.focus(); }, 30);
  }
  function itemsFicha() {
    var h = location.pathname.split('/products/')[1];
    if (!h) return Promise.resolve([]);
    h = h.split('/')[0].split('?')[0];
    return fetch('/products/' + h + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vid = (new URLSearchParams(location.search)).get('variant');
        var fv = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!vid && fv) vid = fv.value;
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0] || (p.variants || [])[0] || {};
        var qEl = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
        return [{ sku: v.sku || '', t: p.title, v: v.title === 'Default Title' ? '' : v.title, q: Math.max(1, parseInt(qEl && qEl.value, 10) || 1), p: (v.price || 0) / 100, url: location.origin + '/products/' + h }];
      })
      .catch(function () { return []; });
  }
  function itemsCarro() {
    return Promise.resolve((cart && cart.items || []).map(function (i) {
      return { sku: i.sku || '', t: i.product_title, v: i.variant_title || '', q: i.quantity, p: (i.final_price || i.price || 0) / 100, url: location.origin + i.url };
    }));
  }
  function enviarCot(e) {
    e.preventDefault();
    var f = e.target, msg = f.querySelector('.nx-cot__msg'), btn = f.querySelector('.nx-cot__send');
    var v = function (n) { var x = f.querySelector('[name="' + n + '"]'); return x ? String(x.value || '').trim() : ''; };
    if (v('nombre').length < 2 || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v('email')) || v('telefono').replace(/\D/g, '').length < 8) {
      msg.textContent = 'Completa tu nombre, un correo válido y tu teléfono.';
      return;
    }
    btn.disabled = true;
    msg.textContent = 'Enviando…';
    var origen = modal.getAttribute('data-origen') || 'carro';
    (origen === 'ficha' ? itemsFicha() : itemsCarro()).then(function (items) {
      var cuerpo = { nombre: v('nombre'), email: v('email'), telefono: v('telefono'), empresa: v('empresa'), rut: v('rut'), comentario: v('comentario'), web: v('web'), origen: origen, pagina: location.href, items: items };
      return fetch(COT.url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(cuerpo) });
    })
      .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
      .then(function (j) {
        btn.disabled = false;
        if (j && j.ok) {
          f.hidden = true;
          var ok = document.createElement('p');
          ok.className = 'nx-cot__ok';
          ok.textContent = COT.gracias || '¡Listo! Recibimos tu solicitud y te contactaremos en horario hábil.';
          f.parentNode.appendChild(ok);
          setTimeout(function () { if (ok.parentNode) ok.parentNode.removeChild(ok); }, 15000);
        } else {
          msg.textContent = (j && j.error) || 'No pudimos enviar tu solicitud. Inténtalo otra vez.';
        }
      })
      .catch(function () { btn.disabled = false; msg.textContent = 'No pudimos enviar tu solicitud. Revisa tu conexión e inténtalo otra vez.'; });
  }

  /* ---------------- 2. Franja de confianza en la ficha ---------------- */
  var ICON = {
    camion: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    tienda: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10v10h16V10M3 10l2-6h14l2 6zM9 20v-5h6v5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    escudo: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    tarjeta: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M3 10h18M7 15h4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    doc: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7zM14 3v4h4M10 12h5M10 16h5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>'
  };
  function pintarFicha() {
    if (!enFicha() || !(T.confianza && T.confianza.length) && !(COT && COT.url && COT.en_ficha)) return;
    if (document.querySelector('.nx-conf')) return;
    var form = document.querySelector('main form[action*="/cart/add"], #MainContent form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form || !form.parentNode) return;
    var ancla = form;
    var eg = form.parentNode.querySelector('.eg-pdp');
    if (eg) ancla = eg;
    var b = document.createElement('ul');
    b.className = 'nx-conf';
    b.innerHTML = (T.confianza || []).map(function (x) {
      return '<li><i>' + (ICON[x.i] || ICON.escudo) + '</i><span>' + esc(x.t) + '</span></li>';
    }).join('') + (COT && COT.url && COT.en_ficha
      ? '<li><i>' + ICON.doc + '</i><span>' + esc(COT.texto_ficha || '¿Necesitas factura o comprar por volumen?') + ' <button type="button" class="nx-conf__link" data-nx-cot="ficha">' + esc(COT.boton || 'Pide una cotización') + '</button></span></li>'
      : '');
    escribir(function () { ancla.parentNode.insertBefore(b, ancla.nextSibling); });
  }

  /* ---------------- Eventos ---------------- */
  document.addEventListener('change', function (e) {
    var x = e.target;
    if (!x || !x.hasAttribute || !x.hasAttribute('data-nx-extra') || !EXTRA) return;
    x.disabled = true;
    var cuerpo = x.checked ? { url: '/cart/add.js', body: { items: [{ id: Number(EXTRA.id), quantity: 1 }] } } : { url: '/cart/change.js', body: { id: String(EXTRA.id), quantity: 0 } };
    fetch(cuerpo.url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo.body) })
      .then(function (r) { if (!r.ok) throw new Error('extra'); location.reload(); })
      .catch(function () { x.disabled = false; x.checked = !x.checked; });
  });
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-nx-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      add.textContent = 'Agregando…';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-nx-add')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        if (enCarro()) location.reload(); else location.href = '/cart';
      }).catch(function () { add.disabled = false; add.textContent = 'Sin stock'; });
      return;
    }
    var cot = e.target.closest && e.target.closest('[data-nx-cot]');
    if (cot) { e.preventDefault(); abrirCot(cot.getAttribute('data-nx-cot')); }
  });

  function pintar() { escribir(function () { pintarSug(); }); pintarFicha(); }

  var RUTA = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var out = _f.apply(this, arguments);
      if (RUTA.test(url)) out.then(leerPronto, function () {});
      return out;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.addEventListener('load', function () { if (RUTA.test(url || '')) leerPronto(); });
    return _open.apply(this, arguments);
  };
  if (window.MutationObserver) {
    var tObs = null;
    new MutationObserver(sinEco(function () {
      clearTimeout(tObs);
      tObs = setTimeout(function () { if (cart) pintar(); }, 300);
    })).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('cart:updated', leerPronto);
  document.addEventListener('cart:refresh', leerPronto);
  window.addEventListener('pageshow', function (e) { if (e.persisted) leerPronto(); });

  pintarFicha();
  leerCarro();
})();
